import Vue from 'vue';
import Vuex from 'vuex'
import { portfolioService} from '@/services/services';
import TradingBlockRemote from '../../services/TradingBlockRemote';
import getters from '../portfolio/getters';
import actions from '../portfolio/actions';
import mutations from '../portfolio/mutations';
import {OrderStatus, OrderType, AssetType, PosititionEffect} from '@/domain/types';
import {OrderAction} from "../../domain/types";
import {formatDate} from '@/utils//formatters';
export const byOrderId = (state, payload, found_cb, nf_cb) => {
  let index = state.items.findIndex((o)=>o.OrderId === payload.OrderId);
  if (index >= 0) {
    found_cb && found_cb(index);
  } else {
    nf_cb && nf_cb();
  }
};

export const byUnderlyingSymbol = (state, payload, found_cb, nf_cb) => {
  let index = state.items.findIndex((o)=>o.UnderlyingSymbol === payload.Symbol);
  if (index >= 0) {
    found_cb && found_cb(index);
  } else {
    nf_cb && nf_cb();
  }
};


export const byBothLegsSymbols = (state, payload, found_cb, nf_cb) => {
  let index = state.items.findIndex((o)=>
    o.Legs[0].Symbol === payload.Legs[0].Symbol &&
    o.Legs[1].Symbol === payload.Legs[1].Symbol
  );
  if (index >= 0) {
    found_cb && found_cb(index);
  } else {
    nf_cb && nf_cb();
  }
};

const state = () => ({
    items: [],
    error: null,
    report_href: null
  });

export default {
  namespaced: true,
  state,
  actions:{
    loadOrders({state, commit, dispatch}, payload){
      commit('loadedOrders', payload);
      if (payload && payload.length>0){
        commit('ORDERS_SUBSCRIBE', payload, {root:true});
        commit('setRefreshingQuotes', payload);
        if (window.allowNotesEditUi)
          dispatch('loadNotes', payload.map(o=>o.OrderId));
      }

    },
    async addNote({state, commit}, payload){

      try {
        commit('beforeNoteChange', payload);
        let dat = await TradingBlockRemote.EditNote(payload);
        commit('editedNote', payload);
      } catch (exc){
        commit('setError', 'Cannot edit note'+ exc);
      }

    },
    async editNote({state, commit}, payload){

      try {
        commit('beforeNoteChange', payload);
        let dat = await TradingBlockRemote.EditNote(payload);
        commit('editedNote', payload);
      } catch (exc){
        commit('setError', 'Cannot edit note' + exc);
      }

    },
    async deleteNote({state, commit}, payload) {

      try {
        commit('beforeNoteChange', payload);
        let dat = await TradingBlockRemote.DeleteNote(payload);
        commit('deletedNote', payload);
      } catch (exc) {
        commit('setError', 'Cannot delete note');
      }
    },
    async loadNotes({state, commit}, payload) {
      try {
      let dat = await TradingBlockRemote.LoadNotes(payload);
      commit('loadedNotes', dat);
      } catch (exc) {
        console.error(exc);
        commit('setError', 'Cannot load notes');
      }
    },
      makeReport({state, commit}){
          var textFile = null;
          const makeTextFile = function (text) {
              var data = new Blob([text], {type: 'text/plain'});

              if (textFile !== null) {
                  window.URL.revokeObjectURL(textFile);
              }

              textFile = window.URL.createObjectURL(data);

              // returns a URL you can use as a href
              return textFile;
          };

          let filled = state.items.filter(o=>o.OrderStatus === OrderStatus.Filled);
          let filled_single = filled.filter(o=>o.OrderClass===1);
          const filled_spread = filled.filter(o=>o.OrderClass===2);

          const filled_opened_buy = filled_single.filter(o=>o.Legs[0].PositionEffect === 1 && o.Legs[0].Action===OrderAction.Buy);
          const filled_closed_sell = filled_single.filter(o=> o.Legs[0].PositionEffect === 2 && o.Legs[0].Action===OrderAction.Sell);
          const filled_opened_sell = filled_single.filter(o=> o.Legs[0].PositionEffect === 1 && o.Legs[0].Action===OrderAction.Sell);
          const filled_closed_buy = filled_single.filter(o=> o.Legs[0].PositionEffect === 2 && o.Legs[0].Action===OrderAction.Buy);

          const spread_open = filled_spread.filter(o=> o.Legs[0].PositionEffect === 1);
          const spread_close = filled_spread.filter(o=> o.Legs[0].PositionEffect === 2);



          var s = "";
          filled_closed_sell.forEach(exit =>{
            var entry = filled_opened_buy.find(op=>op.Legs[0].Symbol == exit.Legs[0].Symbol && op.Date<exit.Date);
            if (entry) {
                s += "BUY, " + entry.Legs[0].Symbol + "," + formatDate(entry.Date) + ", " + formatDate(exit.Date) + ", " + entry.Price + "," + exit.Price + "\n";
            }
          });
          s+ '\n';
          filled_closed_buy.forEach(exit =>{
              var entry = filled_opened_sell.find(op=>op.Legs[0].Symbol == exit.Legs[0].Symbol && op.Date<exit.Date);
              if (entry) {
                  s += "SELL, " + entry.Legs[0].Symbol + "," + formatDate(entry.Date) + " " + formatDate(exit.Date) + ", " + entry.Price + "," + exit.Price + '\n';
              }
          });
          s+ '\n';
          spread_close.forEach(exit =>{
              var entry = spread_open.find(op=>op.Legs[0].Symbol == exit.Legs[0].Symbol && op.Legs[1].Symbol == exit.Legs[1].Symbol && op.Date<exit.Date);
              if (entry) {
                  s += (entry.Legs[0].Action==2?"SELL":"BUY") +"/"+ (entry.Legs[1].Action==2?"SELL":"BUY") +", "+
                      entry.Legs[0].Symbol + " " + entry.Legs[1].Symbol + ","
                      + formatDate(entry.Date) + ", " + formatDate(exit.Date) + ", " + entry.Price + "," + exit.Price + "\n";
              }
          });




          var f = makeTextFile(s);
          state.report_href = f;
      }
  },
  mutations:{
    setRefreshingQuotes(state, payload){

    },
    updateOrderFill(state, payload){
      var pos = state.items.findIndex(o=>o.OrderId===payload.OrderId);
      if (pos>=0){
        Vue.set(state.items, pos, {
          ...state.items[pos],
          OrderStatus: payload.OrderStatus,
          FilledQuantity:payload.FilledQuantity
        });
      }
    },
    updateRealtimeBySymbol (state, payload) {
      if (!payload.spread)
      byUnderlyingSymbol(state, payload, (index)=> {
        if (!payload.bid) return;
        let update = {
          BidPrice: payload.bid,
          AskPrice: payload.ask
        };
        state.items[index] = {...state.items[index], ...update};


      });
      else {
        byBothLegsSymbols(state, payload, (index)=> {
          if (!payload.bid && !payload.ask) return;
          let update = {
            BidPrice: payload.bid,
            AskPrice: payload.ask
          };
          state.items[index] = {...state.items[index], ...update};


        });
      }
    },
    updateOrderStatus(state, payload){
      var pos = state.items.findIndex(o=>o.OrderId===payload.OrderId);
      if (pos>=0){
        Vue.set(state.items, pos, {
          ...state.items[pos],
          OrderStatus: payload.OrderStatus,
        });
      }
    },
    //
    // deletedOrder(state, payload){
    //   var pos = state.items.findIndex(o=>o.OrderId===payload.OrderId);
    //   if (pos>=0){
    //     Vue.delete(state.items, pos);
    //   }
    // },
    loadedOrders(state, payload){
      state.items = payload;

    },
    loadedNotes(state, payload){
      payload.forEach(o=> {
        var found = state.items.find(p=>p.OrderId==o.OrderId);
        if (found){
          byOrderId(state, found, (index)=> {
            let update = {NoteDate: o.Date, Note: o.Description};
            Vue.set(state.items, index, {...state.items[index], ...update})
          });
        }

      });
    },
    deletedNote(state, payload){
      byOrderId(state, payload, (index)=> {
        let update = { note_busy: false, Note: null };
        Vue.set(state.items, index, { ...state.items[index], ...update });
      });
    },
    beforeNoteChange(state, payload){
      byOrderId(state, payload, (index)=> {
        let update = {note_busy: true};
        Vue.set(state.items, index, {...state.items[index], ...update});
      });
    },
    editedNote(state, payload){
      byOrderId(state, payload, (index)=>{
        let update = {Note: payload.Note, note_busy: false};
        Vue.set(state.items, index, {...state.items[index], ...update});
      });
    },
    setError(state, payload){
      state.error = payload;
    },

  }
};
